import { Instagram, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { DoctolibLogo } from "./DoctolibLogo";
import { SITE } from "@/constants/site";
import useI18n from "@/i18n";
import { LEGAL_PATH, pagePath } from "@/i18n/config";

export default function Footer() {
    const { t, lang } = useI18n();

    return (
        <footer className="grad-down py-10" data-testid="footer">
            <hr className="rule-gold mx-auto mb-10 max-w-[1080px]" />
            <div className="mx-auto flex max-w-[1080px] flex-col gap-4 px-5 text-sm text-ink2 md:flex-row md:items-center md:justify-between md:gap-8">
                <p>
                    {t.footer.doctorLine}
                    <span className="block" data-testid="footer-rpps">
                        {t.footer.rpps}
                    </span>
                </p>
                <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <Link
                        to={pagePath(lang, "conseils")}
                        className="transition-colors duration-200 hover:text-terrat"
                        data-testid="footer-conseils-link"
                    >
                        {t.nav.conseils}
                    </Link>
                    <span aria-hidden="true" style={{ color: "var(--c-terral)" }}>·</span>
                    <Link
                        to={LEGAL_PATH}
                        className="transition-colors duration-200 hover:text-terrat"
                        data-testid="footer-legal-link"
                    >
                        {t.footer.legal}
                    </Link>
                    <span aria-hidden="true" style={{ color: "var(--c-terral)" }}>·</span>
                    <Link
                        to={`${LEGAL_PATH}#confidentialite`}
                        className="transition-colors duration-200 hover:text-terrat"
                        data-testid="footer-privacy-link"
                    >
                        {t.footer.privacy}
                    </Link>
                </p>
                <p className="flex flex-wrap items-center gap-x-3 gap-y-1 md:justify-end">
                    <a
                        href={SITE.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 transition-colors duration-200 hover:text-terrat"
                        data-testid="footer-maps-link"
                    >
                        <MapPin size={14} aria-hidden="true" />
                        {SITE.address}
                    </a>
                    <span aria-hidden="true" style={{ color: "var(--c-terral)" }}>·</span>
                    <a
                        href={SITE.doctolibUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 font-semibold text-terrat transition-colors duration-200 hover:text-terrad"
                        data-testid="footer-doctolib-link"
                    >
                        <DoctolibLogo height={17} />
                    </a>
                    <span aria-hidden="true" style={{ color: "var(--c-terral)" }}>·</span>
                    <a
                        href={SITE.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 transition-colors duration-200 hover:text-terrat"
                        data-testid="footer-instagram-link"
                        aria-label={t.footer.instagramAria}
                    >
                        <Instagram size={14} aria-hidden="true" />
                        @{SITE.instagram}
                    </a>
                </p>
            </div>
        </footer>
    );
}
